import { motion } from "framer-motion";
import { Mail, MapPin, Building2 } from "lucide-react";

const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="bg-[#0A0A0A] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
        <motion.div
          {...fadeInUp}
          transition={{ duration: 0.6 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8"
        >
          {/* Brand */}
          <div className="lg:col-span-2">
            <a
              href="#"
              data-testid="footer-logo"
              className="logo-text text-2xl text-white inline-block mb-4"
            >
              Andiaras
            </a>
            <p className="text-[#A1A1AA] text-sm leading-relaxed max-w-md mb-6">
              Gestão profissional de tráfego pago para empresas locais que
              querem crescer com previsibilidade e aumentar o faturamento.
            </p>
            <div className="flex items-center gap-2 text-[#A1A1AA] text-sm">
              <Building2 className="w-4 h-4" />
              <span>Andiaras Negócios Digitais LTDA</span>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-outfit font-semibold text-white mb-4">
              Contato
            </h4>
            <div className="space-y-3">
              <a
                href="mailto:contato@andiaras.com.br"
                data-testid="footer-email"
                className="flex items-center gap-2 text-[#A1A1AA] hover:text-[#2563EB] text-sm transition-colors footer-link"
              >
                <Mail className="w-4 h-4" />
                contato@andiaras.com.br
              </a>
            </div>
          </div>

          {/* Address */}
          <div>
            <h4 className="font-outfit font-semibold text-white mb-4">
              Endereço
            </h4>
            <div className="flex items-start gap-2 text-[#A1A1AA] text-sm">
              <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
              <address className="not-italic leading-relaxed">
                R. Rio Grande do Norte, 1436<br />
                Sala 813/108 – Savassi<br />
                Belo Horizonte - MG<br />
                CEP 30.130-138
              </address>
            </div>
          </div>
        </motion.div>

        {/* Divider */}
        <div className="divider-line my-10" />

        {/* Bottom */}
        <motion.div
          {...fadeInUp}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex flex-col md:flex-row items-center justify-between gap-4"
        >
          <p className="text-[#71717A] text-sm" data-testid="footer-copyright">
            Copyright © {currentYear} Andiaras Negócios Digitais LTDA. Todos os
            direitos reservados.
          </p>
          <p className="text-[#71717A] text-sm" data-testid="footer-cnpj">
            CNPJ: 46.168.695/0001-16
          </p>
        </motion.div>
      </div>
    </footer>
  );
};
